import React, { FunctionComponent, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import GridWrapper from '../../components/shared/grid-wrapper/GridWrapper';
import { useGlobalDispatch } from '../../common/context/AppContext';
import RenderHtml from '../../components/shared/render-html/RenderHtml';
import { track } from 'c9-tracking';
import { IAppProps, REDUCER_KEY } from '../../common/interface/IAppProvider';
import { removeSessionItem } from '../../common/services/StorageService';

const CallMeReceiptView: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const common = props.config.resourceBundles['dk.onsa-common'].read();
    const cb_rmr = props.config.contentBlocks['common/rmo-overlay-receipt'].read();
    const appDispatch = useGlobalDispatch();
    const [initTrack, setInitTrack] = useState(false);

    useEffect(() => {
        if (!initTrack) {
            setInitTrack(true);
            appDispatch({ type: REDUCER_KEY.SET_STATE_CHANGE, payload: true });
            track.convert(`Flow ended up in rmo receipt`);
        }
    }, [initTrack, appDispatch]);

    const submitEventHandler = (e: React.FormEvent) => {
        e.preventDefault();
        track.interact('User confirm RMO receipt and ends flow');
        removeSessionItem('onsa-b2b-session-key');
        window.location.assign('https://www.topdanmark.dk/erhverv/erhvervsforsikringer/');
    };

    return (
        <GridWrapper showChatIcon={false}>
            <form
                noValidate={true}
                onSubmit={submitEventHandler}
                name={`onsa-b2b-rmo-receipt`}
                id={`onsa-b2b-rmo-receipt`}
            >
                <RenderHtml>{cb_rmr.data}</RenderHtml>
                <Button type={'submit'} fullWidth variant="contained">
                    {common['button.finish']}
                </Button>
            </form>
        </GridWrapper>
    );
};

export default CallMeReceiptView;
